import { Box, IconButton, Stack, Typography, Paper } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { Field } from 'formik';
import { EventMap } from '../schema';
import DeleteMapDialog from './DeleteMapDialog';
import { useState } from 'react';
import FormTextInput from './FormTextInput';

interface Props {
    index: number;
    eventName: string;
    map: EventMap;
    deleteable: boolean;
    editMode: boolean;
}

export default function MapListSection(props: Props) {
    const { index, eventName, map, deleteable, editMode } = props;
    const [dialogOpen, setDialogOpen] = useState(false);
    const [mapToDelete, setMapToDelete] = useState<EventMap | undefined>(undefined);

    const handleCloseDialog = () => {
        setDialogOpen(false);
    };

    const handleClickDelete = (map: EventMap) => {
        setMapToDelete(map);
        setDialogOpen(true);
    };

    return (
        <Paper
            elevation={1}
            sx={{
                p: 2,
                mb: 2,
                border: '1px solid #e0e0e0',
                borderRadius: 1,
            }}
        >
            <DeleteMapDialog eventName={eventName} map={mapToDelete} open={dialogOpen} onClose={handleCloseDialog} />
            <Stack direction="column" spacing={2} sx={{ position: 'relative' }}>
                <Box sx={{ position: 'relative' }}>
                    {editMode ? (
                        <Stack direction="row">
                            <Field name={`existingMaps[${index}].name`} component={FormTextInput} label="Map name" sx={{ flexGrow: 1 }} />
                            {deleteable && (
                                <IconButton onClick={() => handleClickDelete(map)}>
                                    <DeleteIcon />
                                </IconButton>
                            )}
                        </Stack>
                    ) : (
                        <Typography variant="h6" sx={{ flex: 1, textAlign: 'center' }}>
                            {map.name}
                        </Typography>
                    )}
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <img style={{ maxWidth: '200px', maxHeight: '200px' }} alt="map bg" src={map.bgImageUrl} />
                </Box>
            </Stack>
        </Paper>
    );
}
